export default __webpack_public_path__ + "static/attractions-img-1-b181fec596c13528d6caa616bed10f17.jpg";